export const THEME_STORAGE_KEY = "cj-theme";

/** @typedef {"light" | "dark"} Theme */

/** @returns {Theme} */
export function getStoredTheme() {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (stored === "light") {
      return "light";
    }
    return "dark";
  } catch {
    return "dark";
  }
}

/** @param {Theme} theme */
export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "dark") {
    root.setAttribute("data-theme", "dark");
  } else {
    root.removeAttribute("data-theme");
  }
}

/** @param {Theme} theme */
export function persistTheme(theme) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    /* ignore quota / private mode */
  }
}

/** @param {Theme} theme */
export function setTheme(theme) {
  applyTheme(theme);
  persistTheme(theme);
}

/** @param {Theme} theme */
export function toggleTheme(theme) {
  return theme === "dark" ? "light" : "dark";
}
